import { PspContext } from "@/config/contexts";
import { useContext } from "react";
import { TopBarMobileProps } from "./topBarMobile.types";
import { Avatar, Text } from "@fluentui/react-components";
import { showTranslated, translate } from "@/config/translator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { useIsTablet } from "@/config/hooks";
import PspTextInput from "../pspTextInput/pspTextInput";
import { faXmark } from "@fortawesome/pro-light-svg-icons";

export function TopBarMobile({
  header,
  avatar,
  onBack,
  rightSide,
  headerTranslation,
  isSearching,
  stopSearching,
  searchValue,
  onChangeSearch,
  searchBoxRef,
  headerString,
}: TopBarMobileProps) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const { lang, user, setLeftBarMobileOpen } = useContext(PspContext);
  const isTablet = useIsTablet();

  if (isTablet) return null;

  return (
    <div
      className="
        z-10
        tablet:hidden
        w-full
        bg-primary
        h-16
        px-4
        flex
        flex-row
        justify-between
        items-center
        shrink-0
        sticky
        top-0
      "
    >
      {isSearching === true &&
      onChangeSearch !== undefined &&
      searchValue !== undefined ? (
        <div className="flex flex-row justify-between items-center w-full gap-2">
          <div className="grow">
            <PspTextInput
              onChange={onChangeSearch}
              value={searchValue}
              label="search"
              ref={searchBoxRef}
              whiteText
            />
          </div>
          <FontAwesomeIcon
            className="text-font-white flex-none px-2"
            size="2xl"
            onClick={stopSearching}
            icon={faXmark}
          />
        </div>
      ) : onBack ? (
        <>
          <div
            onClick={onBack}
            className="size-6 flex justify-center items-center pl-4 pr-8"
          >
            <FontAwesomeIcon
              className="text-font-white"
              size="xl"
              icon={faChevronLeft}
            />
          </div>
          <Text
            size={500}
            weight="semibold"
            align="center"
            className="text-font-white"
          >
            {header
              ? translate(header, lang)
              : headerTranslation
                ? showTranslated(headerTranslation, lang)
                : headerString}
          </Text>
          {!rightSide && <div className="size-6 pr-4 pl-8" />}
        </>
      ) : (
        <div className="flex flex-row gap-3 items-center">
          <Avatar
            name={user?.name}
            size={40}
            onClick={() => setLeftBarMobileOpen(true)}
          />
          <Text size={600} weight="semibold" className="text-font-white">
            {header
              ? translate(header, lang)
              : headerTranslation
                ? showTranslated(headerTranslation, lang)
                : headerString}
          </Text>
        </div>
      )}

      {isSearching !== true && rightSide && (
        <div className="justify-center items-center mr-2">{rightSide}</div>
      )}
    </div>
  );
}
